import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { cmp } from "utils";
import xamatron from "xamatron";
var AiMediaViewerModal = /** @class */ (function (_super) {
    tslib_1.__extends(AiMediaViewerModal, _super);
    function AiMediaViewerModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mediaList = null;
        _this.media = null;
        _this.html = null;
        return _this;
    }
    AiMediaViewerModal.prototype.beforeOpen = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.html = null;
                        this.media = null;
                        this.mediaList = tslib_1.__spread(e.params.media);
                        if (this.mediaList.length == 1 && this.mediaList[0].type != "Pdf") {
                            this.media = this.mediaList[0];
                        }
                        else {
                            this.mediaList.sort(function (a, b) {
                                return cmp(_this.$t("language." + a.language), _this.$t("language." + b.language));
                            });
                        }
                        if (!(this.media && this.media.type == "Html")) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, axios.create({ baseURL: "/" }).get(this.media.url)];
                    case 1:
                        _a.html = (_b.sent()).data;
                        _b.label = 2;
                    case 2:
                        this.$root.$on("back", this.back);
                        return [2 /*return*/];
                }
            });
        });
    };
    AiMediaViewerModal.prototype.closed = function () {
        this.$root.$off("back", this.back);
    };
    AiMediaViewerModal.prototype.back = function (e) {
        e.stop();
        this.$modal.hide("media");
    };
    AiMediaViewerModal.prototype.showMedia = function (media) {
        if (media.type == "Pdf") {
            xamatron.openURL(media.url);
            this.$modal.hide("media");
        }
        else {
            this.media = media;
        }
    };
    AiMediaViewerModal = tslib_1.__decorate([
        Component
    ], AiMediaViewerModal);
    return AiMediaViewerModal;
}(Vue));
export default AiMediaViewerModal;
